module.exports = __webpack_public_path__ + "assets/img/free_9.ec1ee0d8.png";